export const categoriesController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_categories',
        },
      },
    },
    on: {
      type: 'parallel',
      states: {
        layoutReloader: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
            reloading: {
              invoke: {
                src: 'getCategoriesLayoutContent',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
          },
        },
        view_loaded: {
          type: 'parallel',
          states: {
            fetchingData: {
              initial: 'fetchingJackpots',
              states: {
                fetchingJackpots: {
                  invoke: {
                    src: 'fetchJackpots',
                    onDone: {
                      actions: ['updateJackpots', 'categories_reload'],
                      target: 'fetchingTables',
                    },
                  },
                },
                fetchingTables: {
                  invoke: {
                    src: 'fetchTableForPageGames',
                    onDone: {
                      actions: ['updateTables', 'categories_reload'],
                      target: 'fetchStrikeGoldData',
                    },
                  },
                },
                fetchStrikeGoldData: {
                  invoke: {
                    src: 'fetchStrikeGold',
                    onDone: {
                      actions: ['updateStrikeGoldData'],
                      target: 'fetchJackpotsV2',
                    },
                  },
                },
                fetchJackpotsV2: {
                  always: {
                    target: 'done',
                    actions: ['getJackpotsV2'],
                  },
                },
                done: {
                  type: 'parallel',
                  states: {
                    watchJackpots: {
                      invoke: [{ src: 'watchJackpots' }],
                      on: {
                        JACKPOTS_UPDATED: {
                          actions: [
                            'updateJackpots',
                            'jackpotsComponents_reload',
                          ],
                        },
                      },
                    },
                    watchViewLoadedInterval: {
                      invoke: [{ src: 'useInterval' }],
                      on: {
                        INTERVAL_60S: {
                          actions: ['refetchStaleJackpotsV2'],
                        },
                      },
                    },
                    watchLiveTableGames: {
                      invoke: [{ src: 'watchLiveTableGames' }],
                      on: {
                        LIVE_TABLE_GAMES_UPDATED: {
                          actions: ['updateTables', 'categories_reload'],
                        },
                      },
                    },
                  },
                },
              },
            },
            idle: {
              on: {
                REFETCH_CATEGORIES: 'fetchingData',
              },
            },
          },
          onDone: 'idle',
        },
        idle: {
          on: {
            LAYOUT_CHANGE_END: {
              cond: 'isControllerEnabled_categories',
              actions: ['categories_refetch', 'categories_reload'],
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
          cond: 'isControllerDisabled_categories',
        },
      },
    },
  },
};
